import React from 'react';
import {VerdocsAuth} from '@verdocs/web-sdk-react';
import {postErrorToHost, postToHost, useHostResize} from './HostMessages';

export const Auth: React.FC = () => {
  useHostResize('auth');

  return (
    <VerdocsAuth
      style={{width: '100%', height: '100%'}}
      onAuthenticated={(e: any) => postToHost('auth', 'authenticated', {authenticated: !!e.detail?.authenticated})}
      onSdkError={(e: any) => postErrorToHost('auth', e)}
    />
  );
};
